import { LocaleId, TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { FeatureLandingTranslationDictionary } from '../models/i18n/feature-landing-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureLandingTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_EMAIL:
        'Please enter a valid email address',
      SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_REQUIRED:
        'Please enter an email address',
      SIGN_IN_FORM_PASSWORD_ERROR_REQUIRED: 'Please enter a password',
    },
    [LocaleId.English_Ireland]: {
      SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_EMAIL:
        'Please enter a valid email address',
      SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_REQUIRED:
        'Please enter an email address',
      SIGN_IN_FORM_PASSWORD_ERROR_REQUIRED: 'Please enter a password',
    },
    [LocaleId.English_US]: {
      SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_EMAIL:
        'Please enter a valid email address',
      SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_REQUIRED:
        'Please enter an email address',
      SIGN_IN_FORM_PASSWORD_ERROR_REQUIRED: 'Please enter a password',
    },
  };
